import { PATH_COMPETITOR_ANALYSIS } from "~src/routes/paths";
import HeaderBreadcrumbs from "~src/components/HeaderBreadcrumbs";
import { useLocation } from "react-router-dom";
import { navItems } from "./navItems";

export const Header = () => {
  const location = useLocation(); // Get current path from the browser

  // Find the nav item that matches the current path
  const currentNavItem = navItems.find((item) =>
    location.pathname.includes(item.path),
  );

  // Default values in case no match is found
  const heading = currentNavItem ? currentNavItem.label : "Competitor Analysis";
  const subtitle = currentNavItem
    ? currentNavItem.subtitle
    : "Find where your product category is sold worldwide in seconds. Uncover new markets and opportunities with TrendRocket.";

  return (
    <HeaderBreadcrumbs
      heading={heading}
      subtitle={subtitle}
      homeIcon="competitor_analytics"
      links={[
        {
          name: "Competitor Analysis",
          href: PATH_COMPETITOR_ANALYSIS.root,
        },
      ]}
    />
  );
};
